// extracted by mini-css-extract-plugin
export default {"servicesGrid":"OurServices_servicesGrid__Ui01C","serviceCard":"OurServices_serviceCard__7LK5E"};